import Ajax from '../js/common/ajax';

export default {
	list: (params = {}) => Ajax.get('/voucher-word', params)
}
